import React, { useEffect, useState } from 'react';
import axios from '../api/axios';
import Sidebar from '../components/Sidebar';
import { toast } from 'react-toastify';

function AccountsLedger() {
  const [logs, setLogs] = useState([]);
  const [form, setForm] = useState({ type: '', reference: '', debit: '', credit: '', description: '' });

  const fetchLedger = () => {
    axios.get('/accounts/ledger').then(res => setLogs(res.data));
  };

  useEffect(() => { fetchLedger(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/accounts/ledger', form);
      toast.success("Entry added.");
      fetchLedger();
      setForm({ type: '', reference: '', debit: '', credit: '', description: '' });
    } catch {
      toast.error("Error saving entry.");
    }
  };

  return (
    <div className="flex">
      
      <div className=" w-full p-6">
        <h2 className="text-2xl font-bold mb-4">Accounts Ledger</h2>
        <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4 mb-6">
          <select className="border p-2" value={form.type} onChange={e => setForm({ ...form, type: e.target.value })}>
            <option value="">Select Type</option>
            <option value="sale">Sale</option>
            <option value="purchase">Purchase</option>
            <option value="expense">Expense</option>
            <option value="other">Other</option>
          </select>
          <input className="border p-2" placeholder="Reference" value={form.reference} onChange={e => setForm({ ...form, reference: e.target.value })} />
          <input className="border p-2" placeholder="Debit" type="number" value={form.debit} onChange={e => setForm({ ...form, debit: e.target.value })} />
          <input className="border p-2" placeholder="Credit" type="number" value={form.credit} onChange={e => setForm({ ...form, credit: e.target.value })} />
          <input className="col-span-2 border p-2" placeholder="Description" value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} />
          <button className="bg-blue-600 text-white p-2 col-span-2">Add Entry</button>
        </form>

        <table className="table-auto w-full text-left border">
          <thead className="bg-gray-100">
            <tr><th className="p-2 border">Type</th><th className="p-2 border">Ref</th><th className="p-2 border">Debit</th><th className="p-2 border">Credit</th><th className="p-2 border">Desc</th><th className="p-2 border">Date</th></tr>
          </thead>
          <tbody>
            {logs.map(log => (
              <tr key={log.id}>
                <td className="p-2 border">{log.type}</td>
                <td className="p-2 border">{log.reference}</td>
                <td className="p-2 border text-red-600">{log.debit}</td>
                <td className="p-2 border text-green-600">{log.credit}</td>
                <td className="p-2 border">{log.description}</td>
                <td className="p-2 border">{new Date(log.created_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AccountsLedger;